import CreditCardTransactionDetail from './CreditCardTransactionDetail';

export default class CreditCardTransaction {
    // Unique identifier for the transaction
    transactionNumber: number;
    creditCardType: string;
    checkDate: Date;
    closeDate: Date;
    invoiceDate: Date;
    invoiceAmount: number;
    checkNumber: number;
    creditCardTransactionDetail?: CreditCardTransactionDetail[];
}



// WEBPACK FOOTER //
// ./src/models/AP/CreditCardTransaction.ts